// src/lib/utils.js
import React from 'react';

export function isObj(v) {
  return v && typeof v === 'object' && !Array.isArray(v);
}

export function arr(v) {
  return Array.isArray(v) ? v : [];
}

/**
 * API 응답 표준화
 * 기대: { status: boolean, result: { records:[], pageInfo:{}, facet:{} } }
 * 다른 페이지에서도 동일 스키마면 그대로 재사용 가능
 */
export function parsePayload(data) {
  const status = !!data?.status;
  const result = data?.result ?? {};
  const records = arr(result.records);
  const pageInfo = isObj(result.pageInfo) ? result.pageInfo : {};
  const facet = isObj(result.facet) ? result.facet : {};
  const meta = isObj(result.meta) ? result.meta : {};
  return { status, records, pageInfo, facet, meta };
}

/** 숫자 포맷 */
export function formatNumber(n) {
  return typeof n === 'number' ? n.toLocaleString() : String(n ?? '');
}

/** 안전 클램프 */
export function clamp(n, min, max) {
  const x = Number(n) || 0;
  return Math.max(min, Math.min(max, x));
}

/**
 * 서버 쿼리 파라미터 빌드 (페이지 등 공통 매핑)
 * 필요하면 여기서 서버 스펙에 맞게 이름 바꿔서 통일
 */
export function buildListParams({ page = 1, perPage = 20, extra = {} } = {}) {
  return {
    // WP 커스텀이면 아래 키만 서버에 맞게 교체해주면 끝.
    page,
    current_page: page, // 일부 API 호환
    record_per_page: perPage,
    ...extra,
  };
}

/**
 * 텍스트에서 검색어를 하이라이트 처리
 * @param {string} text - 원본 텍스트
 * @param {string} query - 검색어
 * @returns {React.ReactNode} 하이라이트된 JSX 요소
 */
export function highlightText(text, query) {
  if (!text || !query) return text;

  const textStr = String(text);
  const queryStr = String(query).trim();
  if (!queryStr) return textStr;

  // 특수문자 이스케이프
  const escapedQuery = queryStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // 대소문자 구분 없이 검색
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  const parts = textStr.split(regex);

  return parts.map((part, index) => {
    // 각 부분이 검색어와 일치하는지 확인 (대소문자 무시)
    if (part.toLowerCase() === queryStr.toLowerCase()) {
      return (
        <span key={index} className="text-[#4B4DFF]" style={{ display: 'contents' }}>
          {part}
        </span>
      );
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}

/**
 * 로그인 URL에 현재 페이지를 redirect_to로 추가 (SPA 라우팅 시 현재 URL 반영)
 */
export function getLoginUrlWithRedirect() {
  const rv = typeof window !== 'undefined' ? window.rmVars : null;
  const base = rv?.loginUrl ?? '';
  if (!base) return '#';
  const current = typeof window !== 'undefined' ? window.location.href : '';
  return base + encodeURIComponent(current);
}